// extracted by mini-css-extract-plugin
module.exports = {"fontMetropolis":"tooltip_fontMetropolis__ZnEYl","card":"tooltip_card__2gHJd"};